import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServiceHighlights from './components/ServiceHighlights';
import StatsSection from './components/StatsSection';
import AboutPreview from './components/AboutPreview';
import SuccessStoriesPreview from './components/SuccessStoriesPreview';
import TestimonialSection from './components/TestimonialSection';
import WorkshopPreview from './components/WorkshopPreview';
import CalculatorTeaser from './components/CalculatorTeaser';
import CTASection from './components/CTASection';

const Home = () => {
  return (
    <div className="bg-black min-h-screen">
      <Navigation />
      <main>
        <HeroSection />
        <ServiceHighlights />
        <StatsSection />
        <AboutPreview />
        <SuccessStoriesPreview />
        <TestimonialSection />
        <WorkshopPreview />
        <CalculatorTeaser />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
